<template>
<div class="info">
	<div class="title">保单信息</div>
	<Form :label-width="120" class="mt15">
		<FormItem label="保障凭证号：" class="w600">
	        {{info.policyVoucherNo}}
	    </FormItem>
	    <FormItem label="保单号：" class="w600" v-if="info.policyNo">
	        {{info.policyNo}}
			<a :href="info.policyUrl" v-if="info.policyUrl" target="_blank">查看保单</a>
	    </FormItem>
	    <FormItem label="保障状态：" class="w600">
	        {{info.status}}
	    </FormItem>
		<FormItem label="保单起期：" class="w600">
			{{info.effectiveDateStart}}
		</FormItem>
		<FormItem label="保单止期：" class="w600">
			{{info.effectiveDateEnd}}
		</FormItem>
		<FormItem label="保费：" class="w600">
			{{info.amount}}元
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:Object,
	},
	methods:{
		// renew () {
		// 	this.$router.push(`/installer/fillin-order/${this.$route.params.id}?hrCode=${this.info.hrCode}`)
		// }
	}
}
</script>
<style scoped>
	span.price{
		font-size: 18px;
		color:red;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/PolicyBasicInfo.vue